import Api from '../../../helpers/Api';

export const SET_PROPAGE_FAQS = 'SET_PROPAGE_FAQS';
export const setProPageFaqs = (faqs) => ({
    type: SET_PROPAGE_FAQS,
    faqs,
});

export const fetchProPageFaqsIfNeeded = () => (dispatch, getState) => {
    const { proPageFaqs } = getState().proPage;

    if (proPageFaqs.length > 0) {
        return Promise.resolve(1);
    }

    return Api.progressGet(dispatch, '/api/v1/proPage/getFaqs').then((json) => {
        if (json.status !== 'success') {
            throw `error from server: ${json.message}`;
        }

        return dispatch(setProPageFaqs(json.data));
    }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log('fetchProPageFaqsIfNeeded got error: ', error);
    });
};
